export default __webpack_public_path__ + "static/media/metamask.5ef203ca.svg";